/**
 * 预约订单
 */
import { APPOINTMENTORDER } from '../types';

export default {
    name: `${APPOINTMENTORDER}`,
    path: '/appointmentOrder',
    component: () => import(/* webpackChunkName: 'appointmentOrder' */ '@/views/appointmentOrder/'),
    redirect: { name: `${APPOINTMENTORDER}Index` },
    meta: {
        title: '预约订单',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${APPOINTMENTORDER}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'appointmentOrder' */ '@/views/appointmentOrder/home/Home.vue'),
        },
        // 二级页面示例, 没有二级页面就直接删掉
        {
            name: `${APPOINTMENTORDER}Add`,
            path: 'add',
            component: () => import(/* webpackChunkName: 'appointmentOrder' */ '@/views/appointmentOrder/add/Add.vue'),
        },
        {
            name: `${APPOINTMENTORDER}Detail`,
            path: 'detail',
            component: () => import(/* webpackChunkName: 'appointmentOrder' */ '@/views/appointmentOrder/detail/Detail.vue'),
        },
    ],
};
